import { useEffect, useState } from "react";

const code = `export function reconcileFrames(stream: Frame[]) {
  const index = new Map<string, Frame>();

  for (const frame of stream) {
    const current = index.get(frame.id);
    if (!current || frame.revision > current.revision) {
      index.set(frame.id, frame);
    }
  }

  return [...index.values()]
    .sort((a, b) => a.timestamp - b.timestamp);
}`;

export function StealthMode({ onExit }: { onExit: () => void }) {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const timer = window.setInterval(() => setTime(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <main className="stealth-screen" onDoubleClick={onExit}>
    <div className="stealth-topbar"><span>reconcile.ts — workspace</span><span>{time.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })}</span></div>
    <div className="stealth-editor"><div className="line-numbers">{Array.from({ length: 15 }, (_, index) => <span key={index}>{index + 1}</span>)}</div><pre>{code}</pre></div>
    <div className="stealth-status"><span>main*</span><span>Ln 14, Col 2 · UTF-8 · TypeScript</span></div>
    <button className="sr-only" onClick={onExit}>Return to previous screen</button>
  </main>;
}
